import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "struct8";
const idPrev = "struct7";

const prev = `
global parameters:
  - parameter: character
    parameters:
      - parameter: weapon
        choices:
          - choice: dagger
          - choice: ranged
            choices:
              - choice: bow
              - choice: crossbow
          - choice: melee
            choices:
              - choice: axe
              - choice: mace
              - choice: sword
      - parameter: name
        choices:
          - choice: hero
            choices:
              - choice: Peter
              - choice: Susan
              - choice: Edmund
              - choice: Lucy
          - choice: foe
            choices:
              - choice: witch
              - choice: cyclops
              - choice: giant
    logic:
      - constraint: Girls use daggers
        expression: "'name' IN ['hero::Susan', 'hero::Lucy'] => 'weapon' IS 'dagger'"
functions:
  - function: simple
    parameters:
      - linked parameter: hero
        linked to: character
      - linked parameter: foe
        linked to: character
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

function ManualStructures8({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("show-generator-1") && (
        <div className={`${styles["container"]} ${styles["container-st8"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-8"
            className={`${styles["container__text"]} ${styles["container__text-1"]}`}>
            <p>Click here to generate test cases</p>
          </div>

          <Xarrow
            key={`arrow-4-${renderTrigger}`}
            start="tutorial-text-8"
            end="show-generator-1"
            color="#415B32"
            strokeWidth={3}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-st8"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Your model is ready! Click the <b>Generate</b> button at the bottom of the
              screen. As you analyze the results, keep an eye on how the constraints we
              just implemented affect the final output!
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualStructures8;
